// extracted by mini-css-extract-plugin
export var splash = "Splash-module--splash--1yW6C";
export var COLORS = "Splash-module--COLORS--1kg0q";